import { Injectable, Injector } from '@angular/core';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AppConfig } from '@awp/core/config';
import { isNullOrEmpty } from '@awp/core/utils';
import { SirenResponse, SirenEntity, SirenHttp, getAction, AuthenticationService } from '@awp/http';
import { ClientService } from './client.service';
import * as api from '@awp/quote/models';
import { ThemeService } from '@awp/theme';
import { Router } from '@angular/router';

export interface AuthProperties {
  isAuthenticated: boolean;
  accessToken: string;
  refreshToken: string;
}

// Note: This service is used by Eligibility Portal
@Injectable()
export class AuthService1 implements AuthenticationService {

  private _authResponse: SirenResponse;
  private _authProperties: AuthProperties;

  constructor(
    private injector: Injector,
    private http: SirenHttp,
    private router: Router,
    private themeService: ThemeService, 
    private clientService: ClientService) {  }

  get token(): string {
    const result = this._authProperties != null ? this._authProperties.accessToken : null;
    if (isNullOrEmpty(result)) {
      console.log('Token is not defined');
    }
    return result;
  }

  public authenticate(): Observable<SirenResponse> {
    if (this._authResponse != null) {
      return of(this._authResponse);
    }

    const appConfig = this.injector.get(AppConfig);
    const body = this.clientService.getClient();

    if (body != null && typeof body.subscribe === "function") {
      throw Error('Client is not defined');
    }

    const href = `${appConfig.API_BASE_URL}/Application/Authenticate`;

    return this.http.post<any, SirenResponse>({ name: 'Authenticate', href }, body)
      .pipe(
        tap(response => {
          if (!response.properties.isAuthenticated) {
            throw new Error('Authentication failed');
          }
          this._authResponse = response;
          this._authProperties = <AuthProperties>response.properties;
        }),
        catchError((error, caught) => {
            if (error.error) {
              var stopSellerror = error.error.properties.isStopSell;
              if(stopSellerror){
                const tree = this.router.createUrlTree(['/page/not-found']);
                this.router.navigateByUrl(tree, { replaceUrl: true });
                return EMPTY;
              }
          }
          return throwError(error);
        })
      );
  }

  public refresh(): Observable<SirenEntity> {
    const action = getAction(api.ApiAction.ReAuthenticate, this._authResponse);
    const body = {
      accessToken: this._authProperties.accessToken,
      refreshToken: this._authProperties.refreshToken
    };

    return this.http.post<any, SirenEntity>(action, body)
      .pipe(
        tap(response => {
          if (response.properties.isAuthenticated) {
            this._authProperties = <AuthProperties>response.properties;
          }
        })
      );
  }

  public setAuthResponse(authResponse?: SirenResponse, reAuthResponse?: SirenResponse): void {
    this._authResponse = authResponse;

    if (reAuthResponse != null) {
      this._authProperties = <AuthProperties>reAuthResponse.properties;
    } else if (authResponse != null) {
      this._authProperties = <AuthProperties>authResponse.properties
    } else {
      this._authProperties = null;
    }
  }
}
